'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Logo } from './Logo';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  
  const services = [
    { title: "Strony WWW", href: "/uslugi/strony-www" },
    { title: "Optymalizacja SEO", href: "/uslugi/optymalizacja-seo" },
    { title: "Prospekting High Ticket", href: "/uslugi/prospekting-high-ticket" },
    { title: "Pakiet Tożsamości Cyfrowej", href: "/uslugi/pakiet-tozsamosci-cyfrowej" },
  ];

  const otherLinks = [
    //{ label: 'Portfolio', href: '/studia-przypadkow' },
    { label: 'Dokumentacja', href: '/dokumentacja' },
    { label: 'Blog', href: '/blog' },
    { label: 'Kontakt', href: '/kontakt' },
  ];

  // Synchronizacja stanu menu
  useEffect(() => {
    if (isMenuOpen) {
      window.dispatchEvent(new Event('mobile_menu_opened'));
    } else {
      window.dispatchEvent(new Event('mobile_menu_closed'));
    }
  }, [isMenuOpen]);

  return (
    <header 
      className={`fixed top-0 z-50 w-full transition-all duration-300 ${
        isMenuOpen 
          ? 'bg-[#0b0c0e]' 
          : 'bg-[#0b0c0e]/90 backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1250px] items-center justify-between px-6">
        
        {/* ZMIANA: Dodałem klasę 'lg:-ml-6'
            To przesuwa Logo i Linki delikatnie w lewo na dużych ekranach (Desktop),
            nie ruszając przycisku po prawej stronie.
        */}
        <div className="flex items-center gap-12 lg:-ml-6 transition-all">
            <Link href="/" className="flex items-center gap-2 transition hover:opacity-80" onClick={() => setIsMenuOpen(false)} aria-label="Strona główna Webpol">
                <Logo className="h-8" />
            </Link>

            <nav className="hidden md:flex items-center gap-6">
                <div className="group relative h-16 flex items-center">
                    <button className="text-sm font-medium text-gray-300 transition hover:text-white group-hover:text-white flex items-center gap-1">
                        Usługi
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 opacity-50 group-hover:opacity-100">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                        </svg>
                    </button>
                    <div className="absolute top-16 left-0 hidden w-64 flex-col gap-1 rounded-b-xl border border-white/10 bg-[#0b0c0e]/95 p-2 shadow-2xl backdrop-blur-xl group-hover:flex">
                        {services.map((service) => (
                            <Link 
                                key={service.href}
                                href={service.href}
                                className="block rounded-lg px-4 py-3 text-sm text-gray-400 hover:bg-white/10 hover:text-white"
                            >
                                {service.title}
                            </Link>
                        ))}
                    </div>
                </div>

                {otherLinks.map((item) => (
                    <Link 
                        key={item.href} 
                        href={item.href}
                        className="text-sm font-medium text-gray-300 transition hover:text-white"
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {/* PRZYCISK ZAWSZE WIDOCZNY NA DESKTOPIE (POZOSTAJE W TYM SAMYM MIEJSCU) */}
          <Link 
            href="/kontakt"
            className="rounded-full border border-white/20 px-5 py-2 text-sm font-bold text-white transition hover:bg-white hover:text-black animate-in fade-in zoom-in duration-300"
          >
            Darmowa Wycena
          </Link>
        </div>

        <button 
          className="md:hidden text-gray-300 transition hover:text-white"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? "Zamknij menu" : "Otwórz menu"}
        >
          {isMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-8 w-8">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-8 w-8">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>
          )}
        </button>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-x-0 top-16 h-[calc(100vh-64px)] bg-[#0b0c0e] px-6 py-6 md:hidden animate-in slide-in-from-top-5 flex flex-col">
          <nav className="flex h-full flex-col">
            <div className="flex flex-col gap-6">
                <div className="flex flex-col border-b border-white/10 pb-6">
                    <button 
                      onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)}
                      className="flex items-center justify-between text-xl font-medium text-gray-300 hover:text-white"
                    >
                      Usługi
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        fill="none" viewBox="0 0 24 24" 
                        strokeWidth={1.5} stroke="currentColor" 
                        className={`w-6 h-6 transition-transform duration-200 ${isMobileServicesOpen ? 'rotate-180' : ''}`}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>
                    </button>

                    {isMobileServicesOpen && (
                      <div className="mt-4 flex flex-col gap-4 animate-in slide-in-from-top-2 fade-in">
                        {services.map((service) => (
                            <Link 
                                key={service.href} 
                                href={service.href}
                                onClick={() => setIsMenuOpen(false)}
                                className="text-lg text-gray-400 hover:text-white"
                            >
                                {service.title}
                            </Link>
                        ))}
                      </div>
                    )}
                </div>

                {otherLinks.map((item) => (
                  <Link 
                    key={item.href} 
                    href={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-xl font-medium text-gray-300 hover:text-white"
                  >
                    {item.label}
                  </Link>
                ))}
            </div>

            {/* PRZYCISK ZAWSZE WIDOCZNY NA MOBILE */}
            <div className="mt-auto pb-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
              <Link 
                href="/kontakt" 
                onClick={() => setIsMenuOpen(false)}
                className="block w-full rounded-full bg-white py-4 text-center text-lg font-bold text-black shadow-[0_0_20px_rgba(255,255,255,0.3)] transition hover:shadow-[0_0_30px_rgba(255,255,255,0.5)]"
              >
                Darmowa Wycena
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}